import { declareString } from "@1js/localization";

export const SubHeading = declareString("promptLibrary.subHeading", {
  text: "Following prompts were shared by members of this team.",
  comment: "Subheading that appears in MOS app on the Team channel only.",
});

export const SubHeadingLink = declareString("promptLibrary.subHeadingLink", {
  text: "Prompts App",
  comment: "Link that appears in the Subheading text",
});

export const SubHeading2 = declareString("promptLibrary.subHeading2", {
  text: "To explore more prompts, go to the",
  comment: "Subheading that appears in MOS app on the Team channel only.",
});
